import { render, staticRenderFns } from "./chatGroupSettingsDialog.vue?vue&type=template&id=1d87a510&scoped=true"
import script from "./chatGroupSettingsDialog.vue?vue&type=script&lang=js"
export * from "./chatGroupSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./chatGroupSettingsDialog.vue?vue&type=style&index=0&id=1d87a510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d87a510",
  null
  
)

export default component.exports